<template>
  <div class="main">
    <div class="btns">
      <div v-if="searchValIsHide" class="leftSearch">
        <div style="display: flex;">
          <a-button
            type="primary"
            @click="addNursingPopup = true"
            style="margin-right: 10px"
            >添加护工账号</a-button
          >
          <a-input-search
            placeholder="请输入姓名/手机号/手表sn"
            style="width: 240px"
            v-model="searchVal"
            @search="onSearch"
          />
        </div>
        <p>
          共 <span>{{ tableData.length }}</span> 位护理人员
        </p>
      </div>
      <div v-else>
        <span
          >关于“{{ searchVal }}”共搜索到<span style="color: #1890ff">
            {{ total }} </span
          >条结果</span
        >
        <span
          @click="backBtn"
          style="color: #1890ff; cursor: pointer; margin-left: 20px"
          >返回</span
        >
      </div>
    </div>
    <div v-if="total != 0">
      <a-table
        :columns="columns"
        :data-source="tableData"
        bordered
        :pagination="false"
        rowKey="userId"
				class="nursing_deploy-table"
      >
				<template slot="userPhones" slot-scope="scope">
          <div class="user_phones">
						<div class="user_phones-list">
							<div v-for="(item, index) in scope.userPhones || []" v-bind:key="'user_phones' + index" class="user_phones-list-item" :style="{ marginTop: index != 0 ? '5px' : '0px' }">
								<div class="user_phones-list-item-phone">{{ item }}</div>
								<i 
									class="el-icon-close user_phones-list-item-close" 
									@click="clickDeletePhone(scope, item)"
								></i>
							</div>
						</div>
            <div v-if="!scope.userPhones || scope.userPhones.length < 5" class="user_phones-add" :style="{ marginTop: scope.userPhones && scope.userPhones.length > 0 ? '10px' : '0px' }" @click="addPhone(scope)">
							<img src="../../assets/icon_admin_nursing_deploy_add_1.png" alt="" style="width: 20px; height: 20px;" />
						</div>
          </div>
        </template>
        <template slot="nurseWatchList" slot-scope="scope">
          <div class="user_phones nurse_watches">
            <div class="user_phones-list">
              <div
                v-for="(item, index) in scope.nurseWatchList || []"
                v-bind:key="getWatchItemKey(item, index)"
                class="user_phones-list-item"
                :style="{ marginTop: index != 0 ? '5px' : '0px' }"
              >
                <div class="user_phones-list-item-phone">{{ getWatchDisplayText(item) }}</div>
                <i
                  class="el-icon-close user_phones-list-item-close"
                  @click="clickDeleteWatch(scope, item)"
                ></i>
              </div>
            </div>
            <div
              v-if="!scope.nurseWatchList || scope.nurseWatchList.length < 5"
              class="user_phones-add"
              :style="{ marginTop: scope.nurseWatchList && scope.nurseWatchList.length > 0 ? '10px' : '0px' }"
              @click="addWatch(scope)"
            >
              <img src="../../assets/icon_admin_nursing_deploy_add_1.png" alt="" style="width: 20px; height: 20px;" />
            </div>
          </div>
        </template>
        <template slot="beds" slot-scope="scope">
					<div v-if="scope.allBedEnable === 0" style="display: flex;">
							<div class="all_beds_tab">
								<div class="all_beds_tab-text">全部床位</div>
								<i 
									class="el-icon-close all_beds_tab-img" 
									@click="clickDeleteAllBeds(scope)"
								></i>
						</div>
					</div>
					<div v-else class="bed-tab-container" :data-user-id="scope.userId">
						<div 
							v-for="bed in visibleBeds(scope)" 
							:key="bed.id"
							class="bed-tab"
						>
							{{ bed.bedName }}
							<i 
								class="el-icon-close close-btn" 
								@click="delBed(bed.bedId, scope.userId)"
							></i>
						</div>
						<div v-if="remainingBeds(scope) > 0" class="remaining-bed">
							等{{ scope.beds ? scope.beds.length : 0 }}个床位
						</div>
						<div class="bed-add-btn" @click="addBedClick(scope)">
							<img src="../../assets/icon_admin_nursing_deploy_add_1.png" alt="" />
						</div>
					</div>
        </template>
        <template slot="operation" slot-scope="scope">
          <div class="operation">
						<div class="edit_img" @click="edit(scope)" style="margin-right: 15px;"></div>
            <div class="delete_img" @click="delAccount(scope)"></div>
          </div>
        </template>
      </a-table>
    </div>
    <a-empty v-else />
    <a-pagination
      v-model="pageNum"
      :total="total"
      @change="pageChange"
      :pageSize="20"
      :hideOnSinglePage="true"
      show-less-items
      style="text-align: center; margin-top: 20px"
    />
    <!-- 添加护工账号  -->
    <a-modal
      title="添加护工账号"
      :visible="addNursingPopup"
      :maskClosable="false"
      :width="400"
      @cancel="addNursingOff"
      :footer="null"
    >
      <a-form>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: nameColor }">
            <input
              type="text"
              maxlength="18"
              v-model="addListData.name"
              placeholder="请输入姓名"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="nameIcon"
            />
          </div>
          <p class="tips" :style="{ color: nameColor }">
            {{ nameTips }}
          </p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: phoneColor }">
            <input
              type="text"
              autocomplete="off"
              maxlength="11"
              v-model="addListData.phone"
              placeholder="请输入手机号"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="phoneIcon"
            />
          </div>
          <p class="tips" :style="{ color: phoneColor }" v-if="phoneIcon">
            {{ phoneTips }}
          </p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: passwordColor }">
            <input
              type="text"
              placeholder="请输入密码"
              autocomplete="off"
              v-model="addListData.password"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="passwordIcon"
            />
          </div>
          <p class="tips" :style="{ color: passwordColor }" v-if="passwordIcon">
            密码不可为空
          </p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: sparePhoneColor }">
            <input
              type="text"
              autocomplete="off"
              maxlength="11"
              v-model="addListData.reserveMobile"
              placeholder="请输入备用手机号（非必填）"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="sparePhoneIcon"
            />
          </div>
          <p
            class="tips"
            :style="{ color: sparePhoneColor }"
            v-if="sparePhoneIcon"
          >
            {{ sparePhoneTips }}
          </p>
        </a-form-item>
        <a-form-item
          style="
                        margin-top: 40px;
                        text-align: right;
                        margin-bottom: 0;
                    "
        >
          <a-button style="margin-right: 10px" @click="addNursingOff"
            >取消</a-button
          >
          <a-button type="primary" @click="addNursingOk" :loading="loading"
            >添加</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 修改护工账号  -->
    <a-modal
      title="编辑护工账号"
      :visible="editNursingPopup"
      :maskClosable="false"
      :width="400"
      @cancel="editNursingOff"
      :footer="null"
    >
      <a-form>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: nameColor }">
            <input
              type="text"
              v-model="detailsData.name"
              maxlength="18"
              placeholder="请输入姓名"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="nameIcon"
            />
          </div>
          <p class="tips" :style="{ color: nameColor }">
            {{ nameTips }}
          </p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: phoneColor }">
            <input
              type="text"
              autocomplete="off"
              v-model="detailsData.mobile"
              maxlength="11"
              placeholder="请输入手机号"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="phoneIcon"
            />
          </div>
          <p class="tips" :style="{ color: phoneColor }" v-if="phoneIcon">
            {{ phoneTips }}
          </p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: passwordColor }">
            <input
              type="text"
              placeholder="请输入密码"
              autocomplete="off"
              v-model="detailsData.password"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="passwordIcon"
            />
          </div>
          <p class="tips" :style="{ color: passwordColor }" v-if="passwordIcon">
            密码不可为空
          </p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: sparePhoneColor }">
            <input
              type="text"
              autocomplete="off"
              maxlength="11"
              v-model="detailsData.reserveMobile"
              placeholder="请输入备用手机号（非必填）"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="sparePhoneIcon"
            />
          </div>
          <p
            class="tips"
            :style="{ color: sparePhoneColor }"
            v-if="sparePhoneIcon"
          >
            {{ sparePhoneTips }}
          </p>
        </a-form-item>
        <a-form-item
          style="
                        margin-top: 40px;
                        text-align: right;
                        margin-bottom: 0;
                    "
        >
          <a-button style="margin-right: 10px" @click="editNursingOff"
            >取消</a-button
          >
          <a-button type="primary" @click="editNursingOk" :loading="loading"
            >确定</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
		<!-- 新版添加床位 -->
		 <a-modal
		 	v-if="isShowAddBedModal"
      title="添加床位"
      :visible="isShowAddBedModal"
      :maskClosable="false"
      :width="800"
      @cancel="closeAddBedModal"
      :footer="null"
      class="nursing_deploy-add_bed_modal"
    >
			<div>
				<div class="nursing_deploy-add_bed_modal-title">
					<span>共{{ bedValue || 0 }}个床位，已选</span>
					<span style="color: rgba(23, 143, 254, 1); margin-left: 5px; margin-right: 5px;">{{ selectedBedIds ? selectedBedIds.length : 0 }}</span>
					<span>床位</span>
				</div>
				<div>
					<CascadeSelector
						:data="cascadeData"
						:default-value="selectedBedIds"
						:column-width="columnWidth"
						@confirm="handleSelectBeds"
						:isShowInput="true"
						:leafRowSelect="true"
						isShowAllCard
						ref="cascadeSelectorRef"
					>
						<template slot-scope="{isPanelOpen}">
							<div class="selected-tbg">
								<div class="selected-text">
									<span v-if="textShowContent&&textShowContent.length>12" class="contentItem">
										<span class="showContentItem">{{ textShowContent }}</span>
										<span class="contetnSufx">等{{selectedBedIds.length}}个床位</span>
									</span>
									<span v-else>{{ textShowContent }}</span>
								</div>
								<i class="arrow" :class="{ 'up': isPanelOpen }">
									<img src="@/assets/icon_common_special_arrow_9.png" alt="">
								</i>
							</div>
						</template>
					</CascadeSelector>
				</div>
				<div class="modal-footer">
					<div class="modal-footer-cancel" @click="closeAddBedModal">取消</div>
					<div
						class="modal-footer-sure"
						:disabled="selectedBedIds && selectedBedIds.length > 0 ? false : true"
						@click="clickAddBedModalSure"
					>
						确定
					</div>
				</div>
			</div>
			
		</a-modal>
    <!-- 添加床位 -->
    <a-modal
      title="添加床位"
      :visible="addBedPopup"
      :maskClosable="false"
      :width="500"
      @cancel="addBedOff"
      :footer="null"
      class="bedModel"
    >
      <div class="topNum">
        <div>共{{ bedValue }}床位</div>
        <div>
          已选<span> {{ bedNum }} </span>床位
        </div>
      </div>
      <a-tree
        v-if="treeData.length"
        v-model="checkedKeys"
        checkable
        :default-expand-all="autoExpandParent"
        :auto-expand-parent="autoExpandParent"
        :tree-data="treeData"
        style="margin-top: 14px"
      />
      <div class="treeBtn">
        <a-button style="margin-right: 10px" @click="addBedOff">取消</a-button>
        <a-button type="primary" @click="addBedOk" :loading="loading"
          >确定</a-button
        >
      </div>
    </a-modal>
    <!-- 删除弹窗 -->
    <a-modal
      title=""
      :width="200"
      :visible="delNursingPopup"
      :footer="null"
      :closable="false"
    >
      <p class="delTips">
        <a-icon type="exclamation-circle" />你确定要删除吗？
      </p>
      <div class="delBtn">
        <a-button style="margin-right: 10px" @click="delNursingCancel"
          >取消</a-button
        >
        <a-button type="primary" @click="delNursingOk" :loading="loading"
          >确定</a-button
        >
      </div>
    </a-modal>
		<a-modal
			class="nursing_deploy-add_phone_modal"
			title="添加手机号"
			:visible="isShowAddPhoneModal"
			:maskClosable="false"
			width="400px"
			@cancel="addPhoneModalClose"
			:footer="null"
		>
			<!-- 手机号输入框 -->
			<div style="position: relative;">
				<el-input
					v-model="phoneNumber"
					placeholder="请输入手机号"
					:class="{
						'error-input': isErrorAddPhone,
						'normal-input': !isErrorAddPhone
					}"
					@blur="checkPhoneFormat"
					@focus="handleInputFocus"
				/>
				<!-- 错误提示（接口返回错误时显示） -->
				<div v-if="isErrorAddPhone" class="error-tip">手机号重复</div>
			</div>

			<!-- 按钮区域 -->
			<div class="modal-footer">
				<div class="modal-footer-cancel" @click="addPhoneModalClose">取消</div>
				<div
					class="modal-footer-sure"
					:disabled="!isNumberValid()"
					:class="{ 'modal-footer-sure-disabled': !isNumberValid() }"
					@click="handleConfirm"
				>
					确定
			</div>
			</div>
		</a-modal>
		<a-modal
			class="nursing_deploy-del_phone_modal"
			:visible="isShowDelPhoneModal"
			:maskClosable="false"
			width="400px"
			@cancel="delPhoneModalClose"
			:footer="null"
		>
			<div class="tip_view">
				<img class="tip_view-img" src="../../assets/icon_protect_home_phone_alarm_9.png" alt="">
				<div class="tip_view-text">确定要删除 {{ currentDelPhone }} 吗？</div>
			</div>
			<div class="modal-footer">
				<div class="modal-footer-cancel" @click="delPhoneModalClose">取消</div>
				<div
					class="modal-footer-sure"
					@click="deletePhone"
				>
					删除
			</div>
			</div>
		</a-modal>
    <a-modal
      class="nursing_deploy-relate_watch_modal"
      :visible="isShowAddWatchModal"
      :maskClosable="false"
      width="500px"
      :title="relateWatchTitle"
      @cancel="addWatchModalClose"
      :footer="null"
    >
      <div class="watchRelateModal">
        <div class="watchRelateLabel">手表sn</div>
        <a-input
          v-model="watchSnCode"
          :allowClear="true"
          :class="['watchRelateInput', watchError ? 'watchRelateInputError' : '']"
          placeholder="请输入要关联的手表sn"
        />
        <div class="watchRelateError">{{ watchError }}</div>
        <div class="watchRelateFooter">
          <a-button @click="addWatchModalClose">取消</a-button>
          <a-button
            class="watchRelateConfirmBtn"
            type="primary"
            :disabled="isWatchConfirmDisabled()"
            @click="handleWatchConfirm"
            :loading="watchLoading"
          >确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal
      class="nursing_deploy-del_watch_modal"
      :visible="isShowDelWatchModal"
      :maskClosable="false"
      width="400px"
      @cancel="delWatchModalClose"
      :footer="null"
    >
      <div class="tip_view">
        <img class="tip_view-img" src="../../assets/icon_protect_home_phone_alarm_9.png" alt="">
        <div class="tip_view-text">确定要删除 {{ currentDelWatchText }} 吗？</div>
      </div>
      <div class="modal-footer">
        <div class="modal-footer-cancel" @click="delWatchModalClose">取消</div>
        <div
          class="modal-footer-sure"
          @click="deleteWatch"
        >
          删除
      </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import CascadeSelector from '../../component/common/CascadeSelector.vue';

const columns = [
  {
    title: '姓名',
    key: 'name',
    dataIndex: 'name',
    className: 'name-col',
    width: '132px',
    align: 'left',
  },
  {
    title: '账号',
    key: 'mobile',
    dataIndex: 'mobile',
		className: 'mobile-col',
    width: '109px',
    align: 'left',
  },
  {
    title: '手机号',
    width: '125px',
    align: 'left',
    className: 'phone-col',
    customCell: (record) => {
      const hasPhones = record && Array.isArray(record.userPhones) && record.userPhones.length > 0;
      return { class: hasPhones ? 'phone-col-top' : 'phone-col-middle' };
    },
		scopedSlots: { customRender: 'userPhones' },
  },
  {
    title: '手表',
    width: '125px',
    align: 'left',
    className: 'watch-col',
    customCell: (record) => {
      const hasWatches = record && Array.isArray(record.nurseWatchList) && record.nurseWatchList.length > 0;
      return { class: hasWatches ? 'watch-col-top' : 'watch-col-middle' };
    },
		scopedSlots: { customRender: 'nurseWatchList' },
  },
  // {
  //     title: "密码",
  //     key: "password",
  //     dataIndex: "password",
  //     width: "8%",
  //     align: "center",
  // },
  {
    title: '负责床位',
    width: '527px',
    align: 'left',
    className: 'beds-col',
    customCell: (record) => {
      const hasBeds = (record && Array.isArray(record.beds) && record.beds.length > 0) || record.allBedEnable === 0;
      return { class: hasBeds ? 'beds-col-top' : 'beds-col-middle' };
    },
    scopedSlots: { customRender: 'beds' },
  },
  {
    title: '操作',
    align: 'left',
    scopedSlots: { customRender: 'operation' },
  },
];

export default {
	components: { CascadeSelector },
  data() {
    return {
      searchVal: '', //
      tableData: [], // 数据
      columns,
      loading: false, // 添加人员账号确定loading
      addNursingPopup: false, // 添加护工人员账号弹窗状态
      addBedPopup: false, // 添加床位弹窗状态
			isShowAddBedModal: false,
      editNursingPopup: false, // 修改人员弹窗状态
      delNursingPopup: false, // 删除弹窗
      addListData: {
        name: '', // 姓名
        phone: '', // 手机号
        password: '', // 密码
        selectVal: '', // 账号类型
        reserveMobile: '', // 备用手机号
      },
      nameTips: '姓名只支持字母、数字或汉字，最多可输入18个字符', // 姓名填写提示
      nameColor: '#BFBFBF', // 提示默认字体颜色
      nameIcon: false, // 姓名警告状态
      phoneTips: '', // 手机号填写提示
      phoneColor: '#BFBFBF', // 提示默认字体颜色
      phoneIcon: false, // 手机号警告状态
      sparePhoneTips: '', // 手机号填写提示
      sparePhoneColor: '#BFBFBF', // 提示默认字体颜色
      sparePhoneIcon: false, // 手机号警告状态
      passwordColor: '#BFBFBF', // 提示默认字体颜色
      passwordIcon: false, // 密码警告状态
      pageNum: 1,
      pageSize: 20,
      total: 0,
      detailsData: {}, // 获取人员详情

      autoExpandParent: true,
      checkedKeys: [],
      treeData: [], // 床位tree数据
      bedValue: '', // 床的数量
      allCheckedList: [],
      bedNum: '', // 已选床位数量
      searchValIsHide: true,
      bedsDisplayMap: {},
      textMeasureCanvas: null,
      textMeasureCtx: null,

			isShowAddPhoneModal: false,
			currentAddPhoneModel: null,
			phoneNumber: '', // 手机号输入值
      isErrorAddPhone: false, // 是否显示错误状态
			currentDelPhoneModel: null,
			currentDelPhone: null,
			isShowDelPhoneModal: false,

      isShowAddWatchModal: false,
      relateWatchTitle: '关联手表',
      currentAddWatchModel: null,
      watchSnCode: '',
      watchLoading: false,
      watchError: '',
      isShowDelWatchModal: false,
      currentDelWatchModel: null,
      currentDelWatchItem: null,
      currentDelWatchText: '',

			textShowContent: '全部楼层',
			isSelectAllBedIds: false,
      selectedBedIds: [],
			cascadeData: [],
			currentAddBedModel: null,

			columnWidth: '180px'
    };
  },
  watch: {
    checkedKeys(val) {
      var arr = val.filter(function(o) {
        return !isNaN(o);
      });
      this.bedNum = arr.length;
      console.log('onCheck', val);
    },
    watchSnCode(val) {
      const nextValue = (val || '')
        .replace(/[\u4E00-\u9FA5]/g, '')
        .replace(/\s+/g, '');
      if (nextValue !== val) {
        this.watchSnCode = nextValue;
        return;
      }
      if (this.watchError) {
        this.watchError = '';
      }
    },
  },
  created() {
    if (
      this.$getCookie('userInfo').user.roleId == 2 ||
      this.$getCookie('userInfo').user.roleId == 3
    ) {
      this.$router.go(1);
    }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // —— 床位展示计算 ——
    visibleBeds(scope) {
      const entry = this.bedsDisplayMap[scope.userId];
      if (entry && Array.isArray(entry.visible)) return entry.visible;
      return scope.beds || [];
    },
    remainingBeds(scope) {
      const entry = this.bedsDisplayMap[scope.userId];
      if (entry) return entry.remaining || 0;
      return 0;
    },
    getMaxRowsByPhones(userPhones = [], nurseWatchList = []) {
      const phoneCount = Array.isArray(userPhones) ? userPhones.length : 0;
      const watchCount = Array.isArray(nurseWatchList) ? nurseWatchList.length : 0;
      const count = Math.max(phoneCount, watchCount);
      if (count <= 1) return 2;
      if (count === 2) return 3;
      if (count === 3) return 4;
      if (count === 4) return 5;
      return 5; // 5个及以上关联项均按5行
    },
    ensureTextMeasureCtx() {
      if (!this.textMeasureCanvas) {
        this.textMeasureCanvas = document.createElement('canvas');
        this.textMeasureCtx = this.textMeasureCanvas.getContext('2d');
      }
      if (this.textMeasureCtx) {
        this.textMeasureCtx.font = '14px "PingFang SC", "PingFangSC", "Helvetica Neue", Arial, sans-serif';
      }
    },
    measureBedChipWidth(label = '') {
      this.ensureTextMeasureCtx();
      const ctx = this.textMeasureCtx;
      const textWidth = ctx ? ctx.measureText(label).width : 60;
      const paddingWidth = 20; // padding-left + padding-right (10px each)
      const iconWidth = 14; // close icon本身宽度
      const iconMargin = 6; // close icon左侧间距
      return Math.ceil(textWidth + paddingWidth + iconWidth + iconMargin);
    },
    measureRemainingWidth(remaining) {
      this.ensureTextMeasureCtx();
      const ctx = this.textMeasureCtx;
      const text = `等${remaining}个床位`;
      const textWidth = ctx ? ctx.measureText(text).width : 60;
      const sidePadding = 10; // 预留左右间距及 margin/gap 的占位
      return Math.ceil(textWidth + sidePadding);
    },
    measureAddButtonWidth(container) {
      if (container) {
        const addBtn = container.querySelector('.bed-add-btn');
        if (addBtn) {
          const rect = addBtn.getBoundingClientRect();
          return Math.ceil(rect.width);
        }
      }
      return 30; // 默认宽度
    },
    canFitIntoRows(widths, containerWidth, maxRows, gap = 5) {
      let rows = 1;
      let currentWidth = 0;

      for (let i = 0; i < widths.length; i++) {
        const itemWidth = widths[i];
        const needed = currentWidth === 0 ? itemWidth : itemWidth + gap;

        if (itemWidth > containerWidth) return false;

        if (currentWidth + needed <= containerWidth) {
          currentWidth += needed;
        } else {
          rows += 1;
          currentWidth = itemWidth;
        }

        if (rows > maxRows) return false;
      }

      return rows <= maxRows;
    },
    calculateBedsLayoutForUser(user) {
      this.$nextTick(() => {
        const beds = user && Array.isArray(user.beds) ? user.beds : [];
        const userPhones = user && Array.isArray(user.userPhones) ? user.userPhones : [];
        const nurseWatchList = user && Array.isArray(user.nurseWatchList) ? user.nurseWatchList : [];
        const container = document.querySelector(`.bed-tab-container[data-user-id="${user.userId}"]`);
        const containerWidth = (container && container.clientWidth) || 527;
        const maxRows = this.getMaxRowsByPhones(userPhones, nurseWatchList);
        const addBtnWidth = this.measureAddButtonWidth(container);
        const bedWidths = beds.map((bed) => this.measureBedChipWidth(bed.bedName));
        let visibleCount = beds.length;

        const tryFit = (count) => {
          const widths = [];
          for (let i = 0; i < count; i++) {
            widths.push(bedWidths[i]);
          }
          const remaining = beds.length - count;
          if (remaining > 0) {
            widths.push(this.measureRemainingWidth(remaining));
          }
          // 添加按钮始终存在
          widths.push(addBtnWidth);
          return this.canFitIntoRows(widths, containerWidth, maxRows, 5);
        };

        for (let count = beds.length; count >= 0; count--) {
          if (tryFit(count)) {
            visibleCount = count;
            break;
          }
        }

        const remaining = Math.max(0, beds.length - visibleCount);
        this.$set(this.bedsDisplayMap, user.userId, {
          visible: beds.slice(0, visibleCount),
          remaining,
        });
      });
    },
    // 获取表格数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name: this.searchVal,
      };
      this.$get(
        '/api/nurse',
        param,
        (res) => {
          if (res.code == 0) {
            if (res.data.rows) {
              for (let i = 0; i < res.data.rows.length; i++) {
                res.data.rows[i].password = '******';
              }
              this.tableData = res.data.rows;
					this.bedsDisplayMap = {};

          // 数据更新后，计算所有用户的床位展示布局
          this.$nextTick(() => {
            this.tableData.forEach(item => {
              this.calculateBedsLayoutForUser(item);
            });
          });
            } else {
              this.tableData = [];
            }
            this.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 分页
    pageChange(e) {
      console.log(e);
      this.pageNum = e;
      this.getTableData();
    },
    // 监听tree选择
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    // 搜索
    onSearch() {
      this.getTableData();
      this.searchValIsHide = false;
    },
    // 搜索返回
    backBtn() {
      this.searchVal = '';
      this.searchValIsHide = true;
      this.getTableData();
    },
    // 添加人员确定
    addNursingOk() {
      let nameReg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
      // 姓名验证
      if (this.addListData.name) {
        if (
          nameReg.test(this.addListData.name) &&
          this.addListData.name.length <= 18
        ) {
          this.nameTips = '姓名只支持字母、数字或汉字，最多可输入18个字符';
          this.nameColor = '#BFBFBF';
          this.nameIcon = false;
        } else {
          this.nameTips = '姓名只支持字母、数字或汉字，最多可输入18个字符';
          this.nameColor = '#FF4D4F';
          this.nameIcon = true;
          return;
        }
      } else {
        this.nameTips = '姓名不可为空';
        this.nameColor = '#FF4D4F';
        this.nameIcon = true;
        return;
      }
      let phoneReg = /^1[3456789]\d{9}$/;
      // 手机号验证
      if (this.addListData.phone) {
        if (phoneReg.test(this.addListData.phone)) {
          this.phoneColor = '#BFBFBF';
          this.phoneIcon = false;
        } else {
          this.phoneTips = '请输入正确的手机号码';
          this.phoneColor = '#FF4D4F';
          this.phoneIcon = true;
          return;
        }
      } else {
        this.phoneTips = '手机号不可为空';
        this.phoneColor = '#FF4D4F';
        this.phoneIcon = true;
        return;
      }
      if (this.addListData.phone === this.addListData.reserveMobile) {
        this.sparePhoneTips = '备用手机号码不能和账户手机号一样';
        this.sparePhoneColor = '#FF4D4F';
        this.sparePhoneIcon = true;
        return;
      }
      // 密码验证
      if (this.addListData.password) {
        this.passwordColor = '#BFBFBF';
        this.passwordIcon = false;
      } else {
        this.passwordColor = '#FF4D4F';
        this.passwordIcon = true;
        return;
      }
      let param = {
        name: this.addListData.name, // 姓名
        mobile: this.addListData.phone, // 手机号
        password: this.addListData.password, // 密码
        roleId: '3', // 1管理员 2院长 3护工
        reserveMobile: this.addListData.reserveMobile,
      };
      this.loading = true;
      this.$post(
        '/api/user',
        param,
        (res) => {
          if (res.code == 0) {
            this.$message.success('添加成功');
            this.addNursingPopup = false;
            this.getTableData();
            this.addListData = {
              name: '', // 姓名
              phone: '', // 手机号
              password: '', // 密码
              reserveMobile: '', // 备用手机号
            };
            this.nameTips = '姓名只支持字母、数字或汉字，最多可输入18个字符';
            this.nameColor = '#BFBFBF';
            this.nameIcon = false;
            this.phoneColor = '#BFBFBF';
            this.phoneIcon = false;
            this.sparePhoneColor = '#BFBFBF';
            this.sparePhoneIcon = false;
          } else {
            this.$message.error(res.msg);
            if (res.msg == '姓名已经存在') {
              this.nameTips = '姓名在本机构已经存在，请尝试换一个姓名';
              this.nameColor = '#FF4D4F';
              this.nameIcon = true;
            }
          }
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 确定人员取消
    addNursingOff() {
      this.addNursingPopup = false;
      this.addListData = {
        name: '', // 姓名
        phone: '', // 手机号
        password: '', // 密码
        sparePhone: '',
      };
      this.nameTips = '姓名只支持字母、数字或汉字，最多可输入18个字符';
      this.nameColor = '#BFBFBF';
      this.nameIcon = false;
      this.phoneColor = '#BFBFBF';
      this.phoneIcon = false;
      this.sparePhoneColor = '#BFBFBF';
      this.sparePhoneIcon = false;
    },
    // 获取床位tree信息
    getBedTreeData() {
      this.$get(
        '/api/bed/treeList',
        { userId: this.typeId },
        (res) => {
          if (res.code == 0) {
            if (res.data) {
							this.cascadeData = res.data.children ? JSON.parse(JSON.stringify(res.data.children)) : [];
              for (var i = 0; i < res.data.children.length; i++) {
                res.data.children[i].title =
                  res.data.children[i].title +
                  '（' +
                  res.data.children[i].value +
                  '床位）';
                if (res.data.children[i].children) {
                  for (
                    var n = 0;
                    n < res.data.children[i].children.length;
                    n++
                  ) {
                    res.data.children[i].children[n].title =
                      res.data.children[i].children[n].title +
                      '（' +
                      res.data.children[i].children[n].value +
                      '床位）';
                    for (
                      var k = 0;
                      k < res.data.children[i].children[n].children.length;
                      k++
                    ) {
                      res.data.children[i].children[n].children[k].title =
                        res.data.children[i].children[n].children[k].title +
                        '（' +
                        res.data.children[i].children[n].children[k].value +
                        '床位）';
                      for (
                        var j = 0;
                        j <
                        res.data.children[i].children[n].children[k].children
                          .length;
                        j++
                      ) {
                        // res.data.children[i].children[n].children[k].children[j].disabled = res.data.children[i].children[n].children[k].children[j].disabled;
                        // res.data.children[i].children[n].children[k].children[j].disabled = false;
                      }
                    }
                  }
                }
              }
              this.treeData = res.data.children;
              console.log(this.treeData);
              this.bedValue = res.data.value;

							setTimeout(() => {
								if(this.$refs.cascadeSelectorRef) {
									this.columnWidth = ((this.$refs.cascadeSelectorRef.$el.offsetWidth-2)/4) + 'px';
									this.$refs.cascadeSelectorRef.togglePanel()
								}
							}, 150);
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
		getBedIds(e) {
			if (e && e.beds && e.beds.length > 0) {
				let arr = [];
				e.beds.forEach(item => {
					arr.push(item.bedId);
				});
				return arr.map(String);
			} else {
				return [];
			}
		},
    // 添加床位按钮
    async addBedClick(e) {
			if (e.allBedEnable === 0) {
				this.isSelectAllBedIds = true;
			} else {
				this.isSelectAllBedIds = false;
			}
      // this.addBedPopup = true;
			this.currentAddBedModel = JSON.parse(JSON.stringify(e));
			this.selectedBedIds = this.getBedIds(e);
			this.isShowAddBedModal = true;
      this.typeId = e.userId;
      if (e.beds) {
        for (var i = 0; i < e.beds.length; i++) {
          this.allCheckedList.push(e.beds[i].bedId);
          this.checkedKeys.push(e.beds[i].bedId + '');
        }
      } else {
        this.checkedKeys = [];
      }
      this.bedNum = e.beds ? e.beds.length : 0;
      console.log(this.checkedKeys);
      await this.getBedTreeData();
    },
    // 添加床位取消
    addBedOff() {
      this.addBedPopup = false;
      this.checkedKeys = [];
    },
    // 添加床位确定
    addBedOk() {
      let checkedKeys = [];
      for (var i = 0; i < this.checkedKeys.length; i++) {
        checkedKeys.push(this.checkedKeys[i] * 1);
      }
      var arr = checkedKeys.filter(function(o) {
        return !isNaN(o);
      });
      this.bedNum = arr.length;
      console.log(arr, this.allCheckedList);
      let addBedIdsList = [];
      for (var i = 0; i < arr.length; i++) {
        var isEquals = false;
        for (var j = 0; j < this.allCheckedList.length; j++) {
          if (arr[i] == this.allCheckedList[j]) {
            isEquals = true;
            break;
          }
        }
        if (!isEquals) {
          addBedIdsList.push(arr[i]);
        }
      }
      let param = {
        addBedIds: addBedIdsList,
        delBedIds: [],
        userId: this.typeId,
      };
      this.$post(
        '/api/nurse/relateBeds',
        param,
        (res) => {
          if (res.code == 0) {
            this.getTableData();
            this.checkedKeys = [];
            this.addBedPopup = false;
						this.isShowAddBedModal = false;
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
		// 新添加床位
		toAddBed() {

			let originalBeds = this.getBedIds(this.currentAddBedModel);
			let currentBeds = this.selectedBedIds;
			let originalBedsSet = new Set(originalBeds.map(Number));
			let currentBedsSet = new Set(currentBeds.map(Number));
			let addBedIdsList = currentBeds.filter(item => !originalBedsSet.has(Number(item)));
			let delBedIds = originalBeds.filter(item => !currentBedsSet.has(Number(item)));
     
			let addAllBedEnable = 1;
			if (this.isSelectAllBedIds) addAllBedEnable = 0;

      let param = {
        addBedIds: addBedIdsList,
        delBedIds: delBedIds,
        userId: this.typeId,
				addAllBedEnable: addAllBedEnable
      };
      this.$post(
        '/api/nurse/relateBeds',
        param,
        (res) => {
          if (res.code == 0) {
            this.getTableData();
            this.checkedKeys = [];
            this.addBedPopup = false;
						this.isShowAddBedModal = false;
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 获取人员详情
    getDetailsData() {
      this.$get(
        '/api/user/' + this.typeId,
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.detailsData = res.data;
              this.detailsData.password = '';
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 修改人员按钮
    edit(e) {
      this.editNursingPopup = true;
      this.typeId = e.userId;
      this.getDetailsData();
    },
    // 修改人员取消
    editNursingOff() {
      this.editNursingPopup = false;
      this.sparePhoneColor = '#BFBFBF';
      this.sparePhoneIcon = false;
    },
    // 修改人员确定
    editNursingOk() {
      let param = {
        name: this.detailsData.name, // 姓名
        mobile: this.detailsData.mobile, // 手机号
        reserveMobile: this.detailsData.reserveMobile, // 手机号
        password: this.detailsData.password, // 密码
        roleId: 3, // 1管理员 2院长 3护工
        userId: this.typeId,
      };
      if (this.detailsData.password != '') {
        this.passwordColor = '#BFBFBF';
        this.passwordIcon = false;
      } else {
        this.passwordColor = '#FF4D4F';
        this.passwordIcon = true;
        return;
      }
      if (this.detailsData.mobile === this.detailsData.sparePhone) {
        this.sparePhoneTips = '备用手机号码不能和账户手机号一样';
        this.sparePhoneColor = '#FF4D4F';
        this.sparePhoneIcon = true;
        return;
      }
      this.loading = true;
      this.$put(
        '/api/user',
        param,
        (res) => {
          if (res.code == 0) {
            this.$message.success('修改成功');
            this.getTableData();
            this.loading = false;
            this.editNursingPopup = false;
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 删除账号按钮
    delAccount(e) {
      this.typeId = e.userId;
      this.delNursingPopup = true;
    },
    // 确认删除账号
    delNursingOk() {
      this.loading = true;
      this.$delete(
        '/api/user/' + this.typeId,
        {},
        (res) => {
          if (res.code == 0) {
            this.$message.success('删除成功');
            this.getTableData();
            this.delNursingPopup = false;
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.loading = false;
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 删除取消
    delNursingCancel() {
      this.delNursingPopup = false;
    },
    // 删除床位绑定
    delBed(id, userId) {
      let param = {
        addBedIds: [],
        delBedIds: [id],
        userId: userId,
      };
      this.$post(
        '/api/nurse/relateBeds',
        param,
        (res) => {
          if (res.code == 0) {
            this.getTableData();

            this.$message.success('删除成功');
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
		addPhone(item) {
			this.currentAddPhoneModel = item ? JSON.parse(JSON.stringify(item)) : null;
			this.isShowAddPhoneModal = true;
			this.phoneNumber = '';
			this.isErrorAddPhone = false;
		},
		addPhoneModalClose() {
			this.isShowAddPhoneModal = false;
		},
		// 判断手机号是否有效
    isNumberValid() {
			const phoneRegex = /^(?:1[3-9]\d{9}|(?!400)\d{3}-(?:\d{7}|\d{8})|\d{4}-(?:\d{7}|\d{8})|400-(?:\d{3}|\d{4})-\d{4})$/;
			return phoneRegex.test(this.phoneNumber);
    },
		// 输入框聚焦时处理
    handleInputFocus() {
      this.isErrorAddPhone = false; // 聚焦时重置错误状态
    },
    // 检查手机号格式
    checkPhoneFormat() {
    },
    // 点击确定按钮
    handleConfirm() {
			if (!this.phoneNumber) {
				return;
			}
			let param = {
        phone: this.phoneNumber,
				userId: this.currentAddPhoneModel.userId
      };
      this.$get(
        '/api/nurse/addUserPhone',
        param,
        (res) => {
          if (res.code == 0) {
						this.isShowAddPhoneModal = false;
            this.$message.success(res.msg || '添加成功');
						this.getTableData();
          } else {
						if (res.msg == '手机号重复') {
							this.isErrorAddPhone = true;
						} else {
							this.$message.error(res.msg || '服务端发生异常');
						}
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
    },
		clickDeletePhone(item, phone) {
			this.currentDelPhoneModel = item ? JSON.parse(JSON.stringify(item)) : null;
			this.currentDelPhone = phone;
			this.isShowDelPhoneModal = true;
		},
		delPhoneModalClose() {
			this.isShowDelPhoneModal = false;
		},
		deletePhone() {
			let param = {
        phone: this.currentDelPhone,
				userId: this.currentDelPhoneModel.userId
      };
      this.$get(
        '/api/nurse/deleteUserPhone',
        param,
        (res) => {
          if (res.code == 0) {
						this.isShowDelPhoneModal = false;
            this.$message.success(res.msg || '删除成功');
						this.getTableData();
          } else {
						if (res.msg == '手机号重复') {
							this.isErrorAddPhone = true;
						} else {
							this.$message.error(res.msg || '服务端发生异常');
						}
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
		},
      getWatchItemKey(item, index) {
        if (item && item.nurseWatchId !== undefined && item.nurseWatchId !== null) {
          return `nurse_watch_${item.nurseWatchId}`;
        }
        return `nurse_watch_${index}`;
      },
      getWatchDisplayText(item) {
        if (!item) {
          return '';
        }
        return item.watchSnCode || item.snCode || item.watchSn || item.watchCode || '';
      },
      addWatch(item) {
        this.currentAddWatchModel = item ? JSON.parse(JSON.stringify(item)) : null;
        this.isShowAddWatchModal = true;
        this.relateWatchTitle = '关联手表';
        this.watchSnCode = '';
        this.watchError = '';
      },
      addWatchModalClose() {
        this.isShowAddWatchModal = false;
        this.currentAddWatchModel = null;
        this.watchSnCode = '';
        this.watchLoading = false;
        this.watchError = '';
      },
      isWatchConfirmDisabled() {
        return !this.watchSnCode;
      },
      handleWatchConfirm() {
        if (!this.currentAddWatchModel || this.isWatchConfirmDisabled()) {
          return;
        }
        this.watchLoading = true;
        this.watchError = '';
        this.$post(
          '/api/nurseWatch/addNurseWatch',
          {
            userId: this.currentAddWatchModel.userId,
            watchSnCode: this.watchSnCode,
          },
          (res) => {
            if (res.code == 0) {
              this.$message.success(res.msg || '操作成功');
              this.addWatchModalClose();
              this.getTableData();
            } else {
              this.watchError = res.msg || '操作失败';
              this.watchLoading = false;
            }
          },
          (err) => {
            console.log(err);
            this.watchError = err.msg || '服务端发生异常';
            this.watchLoading = false;
          }
        );
      },
      clickDeleteWatch(item, watchItem) {
        this.currentDelWatchModel = item ? JSON.parse(JSON.stringify(item)) : null;
        this.currentDelWatchItem = watchItem ? JSON.parse(JSON.stringify(watchItem)) : null;
        this.currentDelWatchText = this.getWatchDisplayText(watchItem);
        this.isShowDelWatchModal = true;
      },
      delWatchModalClose() {
        this.isShowDelWatchModal = false;
        this.currentDelWatchModel = null;
        this.currentDelWatchItem = null;
        this.currentDelWatchText = '';
      },
      deleteWatch() {
        if (!this.currentDelWatchItem || this.currentDelWatchItem.nurseWatchId === undefined || this.currentDelWatchItem.nurseWatchId === null) {
          this.$message.error('缺少手表关联信息');
          return;
        }
        this.$post(
          '/api/nurseWatch/delNurseWatch',
          {
            nurseWatchId: this.currentDelWatchItem.nurseWatchId,
          },
          (res) => {
            if (res.code == 0) {
              this.isShowDelWatchModal = false;
              this.$message.success(res.msg || '删除成功');
              this.getTableData();
            } else {
              this.$message.error(res.msg || '服务端发生异常');
            }
          },
          (err) => {
            console.log(err);
            this.$message.error('服务端发生异常');
          }
        );
      },
		clickDeleteAllBeds(item) {
			let param = {
        delAllBedEnable: 0,
        userId: item.userId,
      };
      this.$post(
        '/api/nurse/relateBeds',
        param,
        (res) => {
          if (res.code == 0) {
            this.getTableData();
            this.$message.success('删除成功');
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
		},

		closeAddBedModal() {
			this.isShowAddBedModal = false;
			this.checkedKeys = [];
		},
		clickAddBedModalSure() {
			this.toAddBed();
		},
		handleSelectBeds(obj) {
			this.isSelectAllBedIds = obj.isSelectAll;
      this.selectedBedIds = obj.checkIds;
		}
  },
};
</script>

<style lang="scss" scoped>
.main::v-deep {
  padding: 0 !important;
  .btns {
    margin-bottom: 10px;
    .leftSearch {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    p {
      margin-bottom: 0;
      span {
        color: #1890ff;
      }
    }
  }
  .ant-table-thead > tr > th {
    background: #f0f0f0;
		padding-top: 16px;
		padding-bottom: 16px;
  }

	// 表头文字设置
  .ant-table-tbody {
		// 表格内容文字设置
    .name-col {
      font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #262626;
			line-height: 20px;
    }
		.mobile-col {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #262626;
			line-height: 20px;
		}
    .ant-table-row:nth-child(even) {
      background: #fafafa;
    }
  }

  .beds-col-top {
    vertical-align: top;
  }

  .beds-col-middle {
    vertical-align: middle;
  }

  .phone-col-top {
    vertical-align: top;
  }

  .phone-col-middle {
    vertical-align: middle;
  }

  .watch-col-top {
    vertical-align: top;
  }

  .watch-col-middle {
    vertical-align: middle;
  }
  .ant-table-bordered .ant-table-header > table,
  .ant-table-bordered .ant-table-body > table,
  .ant-table-bordered .ant-table-fixed-left table,
  .ant-table-bordered .ant-table-fixed-right table {
    width: 100%;
  }
  .ant-table-content {
    min-height: 1134px;
  }
  .ant-table-thead
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-thead
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: none;
  }
  .ant-table-row td:nth-child(5) {
    padding-bottom: 10px;
  }
  .addBed {
    color: #1890ff;
    display: flex;
    align-items: center;
    .bedChoice {
      display: flex;
      flex-wrap: wrap;
      .bedItem {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        line-height: 32px;
        // padding: 6px 12px;
        // width: 160px;
        background: #e6f7ff;
        color: #1890ff;
        margin-bottom: 10px;
        margin-right: 10px;
        padding: 0 12px;
        span {
          flex: 1;
          text-align: left;
          margin-right: 6px;
        }
        .close {
          color: #1890ff;
          cursor: pointer;
        }
      }
      .bedItem:hover {
        background: #bae7ff;
      }
    }
    .addBtn {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding-bottom: 10px;
      .iconBtn {
        margin-right: 6px;
      }
    }
    .addBtn:hover {
      .iconBtn {
        color: #0072db;
      }
      text-decoration: underline;
    }
  }
  .operation {
    display: flex;
    align-items: center;
    justify-content: center;
    .tableIcon {
      color: #1890ff;
      font-size: 20px;
      margin: 0 0px;
      cursor: pointer;
    }
    .tableIcon:hover {
      color: #0072db;
    }
		.edit_img {
      width: 20px;
      height: 20px;
      cursor: pointer;
      background: url('../../assets/img/icon_admin_nursing_person_edit_1.png') center center no-repeat;
      background-size: contain;
    }
    .edit_img:hover {
      opacity: 0.8;
    }
    .delete_img {
      width: 20px;
      height: 20px;
      cursor: pointer;
      background: url('../../assets/img/icon_admin_nursing_person_delete_1.png') center center no-repeat;
      background-size: contain;
    }
    .delete_img:hover {
			opacity: 0.8;
    }
  }
}
.login_input {
  display: flex;
  position: relative;
  width: 100%;
  height: 16px;
  padding-bottom: 13px;
  border-bottom: 1px solid;
  box-sizing: content-box;
  img {
    width: 16px;
    height: 16px;
    margin: 0 22px 0 16px;
  }
  input {
    flex: 1;
    border: 0; // 去除未选中状态边框
    outline: none; // 去除选中状态边框
    background-color: rgba(0, 0, 0, 0) !important;
    padding-right: 46px;
    height: 16px !important;
    line-height: 16px !important;
  }
  input:-webkit-autofill {
    transition: background-color 5000s ease-in-out 0s;
  }
  input::-webkit-input-placeholder {
    color: #bfbfbf;
  }
  input:-moz-placeholder {
    color: #bfbfbf;
  }
  input::-moz-placeholder {
    color: #bfbfbf;
  }
  input:-ms-input-placeholder {
    color: #bfbfbf;
  }
  .cu {
    cursor: pointer;
  }
}
.tips {
  font-size: 14px;
  margin-bottom: 0;
  line-height: 20px;
  // position: absolute;
  width: 486px;
}
.ant-form-item {
  margin-bottom: 40px;
}
.treeBtn {
  text-align: right;
}
.delTips {
  .anticon {
    color: #faad14;
    margin-right: 10px;
  }
}
.delBtn {
  text-align: right;
  .ant-btn {
    height: 24px;
    line-height: 24px;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
  }
}
.bedModel::v-deep {
  .ant-modal-body {
    position: relative;
    .topNum {
      width: 100%;
      height: 36px;
      background: #f0f0f0;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #262626;
      font-size: 14px;
      padding: 0 12px;
      span {
        color: #1890ff;
      }
    }
  }
}

.bed-tab-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 5px 5px;

  .bed-tab {
    display: inline-flex;
    align-items: center;
    background-color: rgba(24, 144, 255, 0.1);
    border-radius: 4px;
    padding: 5px 10px;
    white-space: nowrap; // 防止标签内容换行，确保宽度稳定
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #5E6779;
		line-height: 20px;

    .close-btn {
      margin-left: 6px;
      cursor: pointer;
      color: RGBA(165, 210, 251, 1);
      &:hover {
        color: RGBA(165, 210, 251, 1);
      }
    }
  }

  .remaining-bed {
    display: inline-flex;
    align-items: center;
    margin: 4px 10px 0 0;
    color: #606266;

    .el-button {
      margin-left: 6px;
    }
  }

  .bed-add-btn {
    height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
    }
  }
}
.user_phones {
	display: flex;
	flex-direction: column;
	.user_phones-list {
		display: flex;
		flex-direction: column;
		.user_phones-list-item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 126px;
			height: 30px;
			background: rgba(24, 144, 255, 0.1);
			border-radius: 4px;
			.user_phones-list-item-phone {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #5E6779;
				line-height: 20px;
				margin-left: 10px;
			}
			.user_phones-list-item-close {
				margin-right: 10px;
				cursor: pointer;
				color: RGBA(165, 210, 251, 1);
				&:hover {
					color: RGBA(165, 210, 251, 1);
				}
			}
		}
	}
	.user_phones-add {
		display: flex;
		align-items: center;
		cursor: pointer;
	}
}

.nurse_watches {
  .user_phones-list-item-phone {
    max-width: 110px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.all_beds_tab {
	display: flex;
	align-items: center;
	background: rgba(24, 144, 255, 0.1);
	border-radius: 4px;
	padding: 5px 10px;
	.all_beds_tab-text {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #5E6779;
		line-height: 20px;
	}
	.all_beds_tab-img {
		width: 11px;
		height: 11px;
		margin-left: 5px;
		margin-top: -3px;
		cursor: pointer;
		color: rgba(165, 210, 251, 1)
	}
}

</style>

<style lang="scss">
.nursing_deploy-table {
	.ant-table-thead > tr > th, .ant-table-tbody > tr > td {
		padding: 10px 10px;
		padding-left: 9px;
	}
}

.nursing_deploy-add_phone_modal {
	.ant-modal-body {
		background: #ffffff;
	}
	.el-input__inner {
		height: 32px;
		padding-left: 12px;
	}
  .el-input {
    width: 100%;
    margin-bottom: 16px;

    &.normal-input {
      .el-input__inner {
        border-color: rgba(217, 218, 217, 1);
        border-radius: 4px;
        color: rgba(38, 38, 38, 1);
        ::placeholder {
          color: rgba(191, 191, 191, 1);
        }
      }
      .el-input__inner:hover,
      .el-input__inner:focus {
        border-color: rgba(24, 144, 255, 0.30);
      }
    }

    &.error-input {
      .el-input__inner {
        border-color: rgba(255, 113, 134, 1);
        color: rgba(255, 113, 134, 1);
      }
    }
  }

  .error-tip {
    color: rgba(255, 113, 134, 1);
    font-size: 12px;
    margin-bottom: 16px;
		position: absolute;
		top: 8px;
		right: 12px;
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
		margin-top: 10px;
		.modal-footer-cancel {
			background: #FFFFFF;
			border-radius: 2px;
			border: 1px solid rgba(0,0,0,0.15);
			padding: 5px 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: rgba(0,0,0,0.65);
			line-height: 22px;
			cursor: pointer;
		}
		.modal-footer-sure {
			background: #1890FF;
			border-radius: 2px;
			padding: 5px 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #FFFFFF;
			line-height: 22px;
			cursor: pointer;
		}
		.modal-footer-sure-disabled {
			opacity: 0.3;
			cursor: not-allowed;
		}
  }
}

.nursing_deploy-del_phone_modal {
	.ant-modal-body {
		background: #ffffff;
	}

	.tip_view {
		display: flex;
		align-items: center;
		margin-top: 30px;
		.tip_view-img {
			width: 16px;
			height: 16px;
			margin-right: 10px;
		}
		.tip_view-text {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #262626;
			line-height: 20px;
		}
	}

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
		margin-top: 52px;
		.modal-footer-cancel {
			background: #FFFFFF;
			border-radius: 2px;
			border: 1px solid rgba(0,0,0,0.15);
			padding: 5px 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: rgba(0,0,0,0.65);
			line-height: 22px;
			cursor: pointer;
		}
		.modal-footer-sure {
			background: #1890FF;
			border-radius: 2px;
			padding: 5px 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #FFFFFF;
			line-height: 22px;
			cursor: pointer;
		}
		.modal-footer-sure-disabled {
			opacity: 0.3;
			cursor: not-allowed;
		}
  }
}

.nursing_deploy-relate_watch_modal {
  .ant-btn {
    border-radius: 2px;
  }

  .watchRelateModal {
    margin-top: -5px;

    .watchRelateLabel {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
      line-height: 20px;
      margin-bottom: 8px;
    }

    .watchRelateError {
      min-height: 22px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #FF4D4F;
      line-height: 22px;
      margin-top: 2px;
      margin-bottom: -24px;
    }

    .watchRelateFooter {
      text-align: right;
      margin-top: 20px;

      .ant-btn {
        min-width: 60px;
        height: 32px;
        border-radius: 2px;
      }

      .ant-btn + .ant-btn {
        margin-left: 10px;
      }

      .watchRelateConfirmBtn.ant-btn-primary[disabled],
      .watchRelateConfirmBtn.ant-btn-primary[disabled]:hover,
      .watchRelateConfirmBtn.ant-btn-primary[disabled]:focus,
      .watchRelateConfirmBtn.ant-btn-primary.ant-btn-disabled,
      .watchRelateConfirmBtn.ant-btn-primary.ant-btn-disabled:hover,
      .watchRelateConfirmBtn.ant-btn-primary.ant-btn-disabled:focus {
        background: rgba(24, 144, 255, 0.3);
        border-color: rgba(24, 144, 255, 0);
        color: rgba(255, 255, 255, 1);
        box-shadow: none;
      }
    }
  }

  .ant-input-affix-wrapper {
    padding: 0 0px;
    border-radius: 2px;
    box-shadow: none;
  }

  .ant-input-affix-wrapper .ant-input {
    height: 32px;
    padding: 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #262626;
    line-height: 22px;
    padding-left: 12px;
    padding-right: 12px;
    box-shadow: none;
  }

  .ant-input-affix-wrapper .ant-input::placeholder,
  .ant-input-affix-wrapper .ant-input::-webkit-input-placeholder,
  .ant-input-affix-wrapper .ant-input::-moz-placeholder,
  .ant-input-affix-wrapper .ant-input:-ms-input-placeholder {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.25);
    line-height: 22px;
  }

  .ant-input-affix-wrapper .ant-input-suffix {
    top: 16px;
    right: 13px;
  }

  .ant-input-affix-wrapper .ant-input-clear-icon {
    font-size: 18px;
    color: #bfbfbf;
  }

  .watchRelateInputError.ant-input-affix-wrapper,
  .watchRelateInputError.ant-input-affix-wrapper:hover,
  .watchRelateInputError.ant-input-affix-wrapper.ant-input-affix-wrapper-focused {
    border-color: #ff4d4f;
    box-shadow: none;
  }

  .watchRelateInputError.ant-input-affix-wrapper .ant-input {
    color: #ff4d4f;
    border-color: rgba(255, 77, 79, 1);
  }
}

.nursing_deploy-del_watch_modal {
  .ant-modal-body {
    background: #ffffff;
  }

  .tip_view {
    display: flex;
    align-items: center;
    margin-top: 30px;
    .tip_view-img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    .tip_view-text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
      line-height: 20px;
    }
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 52px;
    .modal-footer-cancel {
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid rgba(0,0,0,0.15);
      padding: 5px 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0,0,0,0.65);
      line-height: 22px;
      cursor: pointer;
    }
    .modal-footer-sure {
      background: #1890FF;
      border-radius: 2px;
      padding: 5px 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 22px;
      cursor: pointer;
    }
  }
}

.nursing_deploy-add_bed_modal {
	.nursing_deploy-add_bed_modal-title {
		margin-bottom: 4px;
		span {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #58595A;
			line-height: 20px;
		}
	}
	.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
		margin-top: 24px;
		.modal-footer-cancel {
			background: #FFFFFF;
			border-radius: 2px;
			border: 1px solid rgba(0,0,0,0.15);
			padding: 5px 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: rgba(0,0,0,0.65);
			line-height: 22px;
			cursor: pointer;
		}
		.modal-footer-sure {
			background: #1890FF;
			border-radius: 2px;
			padding: 5px 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #FFFFFF;
			line-height: 22px;
			cursor: pointer;
		}
		.modal-footer-sure-disabled {
			opacity: 0.3;
			cursor: not-allowed;
		}
  }
}

</style>